import { ChangeDetectorRef, Component, Inject, NgZone } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog';
import { ActivityWatcher } from '../../../activity-watcher.service';
import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { PageAlertComponent } from '../page-alert/page-alert.component';
import { DialogContentFocusableDirective } from '../../directives/dialog-content-focusable.directive';
import { MatButton } from '@angular/material/button';
import { CdkCopyToClipboard } from '@angular/cdk/clipboard';
import { JsonPipe } from '@angular/common';

@Component({
  selector: 'app-global-error-modal',
  templateUrl: './global-error-modal.component.html',
  styleUrls: ['./global-error-modal.component.scss'],
  imports: [
    MatDialogTitle,
    CdkDrag,
    CdkDragHandle,
    CdkScrollable,
    MatDialogContent,
    DialogContentFocusableDirective,
    PageAlertComponent,
    MatDialogActions,
    MatButton,
    MatDialogClose,
    CdkCopyToClipboard,
    JsonPipe,
  ],
})
export class GlobalErrorModalComponent {
  config: any = {};
  constructor(
    private dialogRef: MatDialogRef<GlobalErrorModalComponent>,
    private ngZone: NgZone,
    private readonly activityWatcher: ActivityWatcher,
    private readonly changeDetectorRef: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) private readonly data: any
  ) {
    setTimeout(() => {
      this.config = data;
      this.changeDetectorRef.detectChanges();
    }, 0);
  }

  close(): void {
    // using ngZone because of this: https://github.com/angular/components/issues/13640
    this.ngZone.run(() => {
      this.dialogRef.close();
    });
  }

  generateHar() {
    const blobLink = document.getElementById('blobLink');
    const blobUrl = this.activityWatcher.getHar();
    blobLink.setAttribute('href', blobUrl);
    blobLink.setAttribute('download', `${new Date().toISOString()}.har`);
    blobLink.click();
  }
}
